module.exports = __webpack_public_path__ + "static/media/filled-checkbox.42cb698a.svg";